import React from 'react';
import { Box } from '@mui/material';
import AutoPlayVideo from './components/AutoPlayVideo';

export type VideoProps = {
  value: {
    title: string;
    description: string
    videoFile: {
        asset: {
            mimeType: string
            url: string;            
        }
    }
  };
};

const Video = ({value}: VideoProps) => {    

  return (
    <Box
      sx={{        
        borderRadius: '9px',
        overflow: 'hidden',        
      }}
    >        
        <AutoPlayVideo url={value?.videoFile?.asset?.url ?? null} alt='Video Embed'/>
    </Box>
  );

};

export default Video;
